
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class DataQualityWorkflowInstanceGrid extends SiteEntityGrid<WorkflowInstanceRow, any> {
        protected getColumnsKey() { return 'Workflow.DataQualityWorkflowInstance'; }
        protected getDialogType() { return DataQualityWorkflowInstanceDialog; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getService() { return WorkflowInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("Data Quality Exceptions");
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            new Serenity.DraggableGroupingMixin({
                grid: this
            });
        }

        protected createQuickFilters() {
            super.createQuickFilters();

            var statusCode = this.findQuickFilter(Serenity.Select2Editor, 'StatusCode');
            if (statusCode) {
                var statusCodeSelect2 = statusCode.element.data('select2');
                if (statusCodeSelect2) {
                    statusCode.element.attr("placeholder", "--status--");
                    statusCodeSelect2.search.val("--status--")
                        .addClass("select2-default");
                }
            }
        }

        getIncludeColumns(include) {
            super.getIncludeColumns(include);
            include[WorkflowInstanceRow.Fields.Priority] = true;
            include[WorkflowInstanceRow.Fields.HelpText] = true;
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            return opt;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[WorkflowInstanceRow.Fields.WorkflowClass1] = "MX:DQ TEST RESULT";

            return true;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var trackingId = Q.tryFirst(columns, x => x.field == WorkflowInstanceRow.Fields.C1);
            if (trackingId) {
                trackingId.format = ctx => {
                    if (!ctx.value || !ctx.item.Txt2)
                        return "";

                    var url = ctx.item.Txt2 as string;
                    if (!url || !Q.endsWith(url, '/'))
                        url += '/';
                    url += ctx.value;
                    return `<a href="${Q.attrEncode(url)}" target="_blank"><i class="fa fa-external-link"></i> ${Q.htmlEncode(ctx.value)}</a>`; 
                };
            }

            var testCode = Q.tryFirst(columns, x => x.field == WorkflowInstanceRow.Fields.Key1);
            if (testCode) {
                testCode.format = ctx => {
                    var item = ctx.item as WorkflowInstanceRow;
                    if (!item.Key1 || !item.Key2) {
                        if (!(ctx.item as WorkflowInstanceRow).WorkflowInstanceId)
                            return Q.htmlEncode(ctx.value);
                        return "";
                    }
                    return `<a class="inline-action view-test-results" href="javascript:;" title="details"><i class="fa fa-search"></i> ${Q.htmlEncode(ctx.value)}</a>`;
                }
            }

            var exceptionUrl = Q.tryFirst(columns, x => x.field == WorkflowInstanceRow.Fields.Txt1);
            if (exceptionUrl) {
                exceptionUrl.format = ctx => {
                    if (!ctx.value)
                        return "";

                    return `<a href="${Q.attrEncode(Q.resolveUrl(ctx.value))}" target="_blank" style="color: red !important"><i class="fa fa-exclamation-circle"></i> View</a>`;
                };
            }
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as WorkflowInstanceRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('view-test-results')) {
                    Data.TestResultService.List({
                        ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                        EqualityFilter: <Data.TestResultRow>{
                            TestCode: item.Key1,
                            BatchId: item.Key2 as any
                        }
                    },
                        response => {
                            if (!response.Entities.length) {
                                Q.notifyError("Can't locate the test results related to this instance!");
                                return;
                            }

                            var dlg = new Data.TestResultDialog();
                            this.initDialog(dlg);
                            dlg.loadByIdAndOpenDialog(response.Entities[0].RowId);
                        }
                    );
                }
            }
        }
    }
}